import React from 'react';
import { useQuery } from '@apollo/client';
import { Select, Space, Typography } from 'antd';
import { GET_PROJECT_STATUS } from 'gql/projectStatus';
import { useHasScopeType } from 'hooks';

const { Text } = Typography;
const { Option } = Select;

const ProTableSearchProjectStatus = ({ value, onChange }) => {
  const { data, loading } = useQuery(GET_PROJECT_STATUS);
  const { hasScopeType: canViewPreparation } =
    useHasScopeType('VIEW_ALL_PROJECT');
  const options = data
    ? data.projectStatus
        .filter(
          ({ controlType }) =>
            canViewPreparation || controlType !== 'PREPARATION'
        )
        .map(({ id, name, description }) => ({
          id,
          name,
          description,
        }))
    : [];

  return (
    <Select
      allowClear
      placeholder="Please select"
      loading={loading}
      value={value}
      onChange={onChange}
      optionLabelProp="label"
    >
      {options.map(({ id, name, description }) => (
        <Option key={id} value={id} label={name}>
          <Space direction="vertical">
            {name}
            <Text type="secondary">{description}</Text>
          </Space>
        </Option>
      ))}
    </Select>
  );
};

export default ProTableSearchProjectStatus;
